import { DataAttributeDefinitions } from 'scrivito'

import { pisaActivityDocumentRelationDataClass } from './Pisa/pisaActivityDocumentRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const ActivityDocumentRelation =
  pisaActivityDocumentRelationDataClass(attributes)
